import { render, staticRenderFns } from "./EditOrgDetailsForm.vue?vue&type=template&id=4ec0158b&scoped=true&"
import script from "./EditOrgDetailsForm.vue?vue&type=script&lang=js&"
export * from "./EditOrgDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./EditOrgDetailsForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./EditOrgDetailsForm.vue?vue&type=style&index=1&id=4ec0158b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec0158b",
  null
  
)

export default component.exports